<ng-container *transloco="let t">
  <form [formGroup]="inputForm">
    <app-admin-card-with-title [cardTitle]="t('organiser.payment.data.tax.data')"
                               [isContentVisible]="!isTaxDataCollapsed" [showToggleButton]="true"
                               [removeTopMargin]="true">
      <div class="row">
        <div class="col-12 col-xxl-2">
          <div class="form-floating mb-3">
            <div class="form-check form-switch mt-3 mb-4">
              <input class="form-check-input" type="checkbox" id="mandatoryPayment" formControlName="paysPDV"
                     placeholder='{{t("organiser.payment.data.paysPDV")}}'>
              <label class="form-check-label" for="mandatoryPayment">
                {{ t("organiser.payment.data.paysPDV") }}
                @if (inputForm.controls['paysPDV'].errors?.['required']) {
                  <span>*</span>
                }
              </label>
              @if (inputForm.controls['paysPDV'].touched) {
                <div>
                  @for (errorMessage of inputForm.controls['paysPDV']!.errors | errorMessages:'paysPDV';track errorMessage) {
                    <span class="errorMes pt-1">{{ errorMessage }} </span>
                  }
                </div>
              }
            </div>
          </div>
        </div>
        <div class="col-12 col-xxl-5">
          <div class="pb-3">
            <app-input formControlName="taxNumber" label="organiser.payment.data.taxNumber"/>
          </div>
        </div>
        <div class="col-12 col-xxl-5">
          <div class="pb-3">
            <app-select formControlName="defaultCurrency"
                        [hasDefault]="true" [items]="currencies" [valueKey]="'id'" [labelKey]="'name'"
                        label="organiser.payment.data.defaultCurrency"/>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 ">
          <app-textarea formControlName="exemptionText" id="exemptionText"
                        label="organiser.payment.data.exemptionText" rows="3"/>
        </div>
      </div>
    </app-admin-card-with-title>
    <app-admin-card-with-title [cardTitle]="t('organiser.payment.data.bank.data')"
                               [isContentVisible]="!isBanksDataCollapsed" [showToggleButton]="true">
      <div class="row">
        <div class="col-12 col-lg-4">
          <div class="pb-3">
            <app-input formControlName="iban" label="organiser.payment.data.iban"/>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="pb-3">
            <app-input formControlName="swift" label="organiser.payment.data.swift"/>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="pb-3">
            <app-input formControlName="bankName" label="organiser.payment.data.bank.name"/>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-4">
          <div class="pb-3">
            <app-input formControlName="bankAddress" label="organiser.payment.data.bank.address"/>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="pb-3">
            <app-input formControlName="bankPlace" label="organiser.payment.data.bank.place"/>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="pb-3">
            <app-input formControlName="bankZip" label="organiser.payment.data.bank.zip"/>
          </div>
        </div>
      </div>
    </app-admin-card-with-title>
    <app-action-buttons-row (onSave)="onSave()" [backVisible]="authenticationService.isAdministrator()"/>
  </form>
</ng-container>
